/**
 * created by tian ruo jun
 约稿稿件列表页面
 *
 */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import ManuscriptsSubmitted from "../manuscriptsSubmitted/ManuscriptsSubmitted";
import {getInfoFromLocalStorage} from "../../../actions";
import {Button, Dropdown, Icon, Menu, message, Popconfirm, Popover} from "antd";
import RenderPicker from "../manuscriptsSubmitted/component/renderPicker";
import {HEADER_HEIGHT} from "../../../constants";
import MyTable from "../component/MyTable";
import DetailsModal from "../../sysManagement/selectedTopicManagement/components/detailsModal";
import {contentParser} from "../../../base/BaseComponent";

export default class AppointmentStory extends ManuscriptsSubmitted {
    constructor(props) {
        super(props);
        this.state.configKey = ""
    }
    // tabbar数据
    getNavigationBarData = () => {
        return (
            [
                {
                    key: '全部稿件',
                    url: '/cm-sites-pms/story/getManuscriptsStory',
                    params: {
                        status: ""
                    }
                },
                {
                    key: '待我审核',
                    url: '/cm-sites-sys/process/getTodoList',
                    params: {
                        showData:true,
                        operatorUser: this.getInfo().currentUser.id,
                        activitiCategoryKeys: ['yggj'],
                        title: '',
                        // category: 'manuscripts',
                        page:{
                            start: 1,
                            size: 10,
                        }
                    }
                },
                {
                    key: '已采用',
                    url: '/cm-sites-pms/story/getManuscriptsStory',
                    params: {
                        status: "已采用"
                    }
                },
                {
                    key: '已弃用',
                    url: '/cm-sites-pms/story/getManuscriptsStory',
                    params: {
                        status: "已弃用"
                    }
                },
            ]
        )
    };

    render() {
        let sysConfigData=JSON.parse(this.sysConfigGetValueByKey("busAppointment",'{}'));
        contentParser(sysConfigData,sysConfigData);
        console.log("sysConfigData===============",sysConfigData);
        let {tabKey, total, dataSource, reviewData, params, treeData} = this.state;
        let navigationBarDate = this.getNavigationBarData();
        let props = {
            onChange: this.onChange,
            dataSource: dataSource, //表格数据
            total: total,
            navigationBarDate: navigationBarDate,
            columns: this.getColumns(),  //表格表头
            reviewData: reviewData,
            tabChange: this.tabChange,
            params: params,
            tabKey: tabKey,
            // tableWidth: window.innerWidth - 550 - 64,
            tableHeight: window.innerHeight - HEADER_HEIGHT - 101 - 20 - 81 - 15 - 15,
            // width: window.innerWidth - 550,
            treeData: treeData
        };
        return (
            <div>
                <MyTable
                    {...props}
                ></MyTable>
                {/*查看任务弹框*/}
                {this.renderModal()}
                {/*查看发布弹框*/}
                {this.renderViewPublishModal()}
                {/*查看提交媒体弹框*/}
                {this.renderSubmitMediaModal()}
                {/*渲染图文合成器*/}
                {this.showMergeMaterial?this.renderMergeMaterial():null}
                {/*渲染约稿信息*/}
                {
                    JSON.stringify(sysConfigData) === "{}" ? <></> : (
                        <DetailsModal
                            ref={ref=>this.detailsModal=ref}
                            sysConfigData={sysConfigData}
                            details={"约稿详情"}
                        />
                    )
                }
            </div>
        );
    }

    // 表头
    getColumns = () => {
        let columns = super.getColumns();
        if(columns && columns.length) {
            columns.forEach((item,index)=>{
                if(item.key === 'action') {
                    columns[index] = {
                        ...item,
                        render: (text, record) => {
                            let currentUser = getInfoFromLocalStorage("currentUser");
                            let currentDeptValue;
                            if(
                                currentUser &&
                                currentUser["defaultInfo"] &&
                                currentUser["defaultInfo"]["dept"] &&
                                currentUser["defaultInfo"]["dept"]["name"]
                            ) {
                                currentDeptValue = currentUser["defaultInfo"]["dept"]["name"];
                            }

                            let btns = [];

                            // downloadBtn  Start
                            let downloadBtn = <Button key={"downloadBtn"} size={'small'} type={'link'} onClick={() => {
                                this.download(record)
                            }} style={{marginLeft: -8}}>下载</Button>;
                            btns.push(downloadBtn);
                            // downloadBtn  end

                            // otherBtn  Start
                            // if((record.statusName == '发布' || record.statusName == '已发布') && record.mainMedia && record.mainMedia.mediaTypeCode === "webNews") {
                            if(record.variableFields&&record.variableFields.publish===1) {
                                let otherBtn =  <Button key={"otherBtn"} size={'small'} type={'link'} className='aPopover' style={{background:"unset"}} onClick={()=>{
                                    this.getPublishList(record.id, (data)=>{
                                        let publishMediaListData = this.convertDataByPublishList(data);
                                        this.setState({publishMediaListModalVisible:true, publishMediaListData})
                                    });
                                }}>查看发布</Button>;
                                btns.push(otherBtn);
                            }
                            // otherBtn  end

                            // storyPicker  Start
                            if(["发布", "已发布", "撤稿", "已撤稿", "已采用"].indexOf(record.statusName) > -1){
                                let storyPicker = <Popover key={"storyPicker"}
                                    // content={this.renderPicker({id:record.id,data:record})}
                                                           content={<RenderPicker id={record.id} data={record} treeData={this.state.treeData}/>}
                                                           placement="bottomRight"
                                >
                                    <Button size={'small'} type={'link'} className='aPopover' style={{background:"unset"}}>拾取至</Button>
                                </Popover>;
                                btns.push(storyPicker);
                            }
                            // storyPicker  end


                            // mergeMaterial  Start
                            if(record.mainMedia && record.mainMedia.mediaTypeCode === "material" && this.showMergeMaterial) { // 主媒体为微信
                                if (record.statusName &&
                                    (
                                        // record.statusName.startsWith(`提交至${currentDeptValue}`) ||
                                        // record.statusName.indexOf("修改完成") !== -1 ||
                                        record.statusName.indexOf("已采用") !== -1
                                    )) { // 状态为提交至
                                    // if(this.getMediaPower(record.mainMedia.id)) { // 有当前媒体权限
                                    if(this.currentUserHasMediaAuth(record.mainMedia.id)) { // 有当前媒体权限
                                        let mergeMaterial = <Button key={"mergeMaterial"} size={'small'} type={'link'} onClick={()=>{
                                            this.getMediaInfo(record.mainMedia.id, ({code,log})=>{
                                                if(code===1) {
                                                    // 取当前媒体
                                                    let oldSynthesizer = this.state.synthesizer;
                                                    // 如果当前媒体与之前选择不一致则覆盖掉，并且清空合成器
                                                    if(!oldSynthesizer || (oldSynthesizer.id != record.mainMedia.id)) {
                                                        this.state.synthesizer = record.mainMedia;
                                                        this.state.wechatList = [];
                                                    }
                                                    // 如果合成器中没有这篇稿子则添加
                                                    if(!(this.state.wechatList && this.state.wechatList.some(item=>item.id==record.id))) {
                                                        this.state.wechatList.push(record);
                                                    }
                                                    // 打开合成器
                                                    this.setState({},()=>{
                                                        // 展开合成器
                                                        this.simpleFloatTool.setMinus(false);
                                                        // 显示合成器
                                                        this.simpleFloatTool.show()
                                                    });
                                                }
                                                if(code===0 && log && (typeof log === "string")) {
                                                    message.warning(log)
                                                }
                                                if(code===-1 && log) {
                                                    console.error(log)
                                                }
                                            });

                                        }}>图文合成器</Button>;
                                        btns.push(mergeMaterial);
                                    }
                                }
                            }
                            // mergeMaterial  end

                            // failure  Start
                            if(record.statusName == '发布失败') {
                                let failure = (<span  key={"failure"} className={"Failure"}>
                                <Popconfirm getPopupContainer={triggerNode => triggerNode.parentNode}
                                            title={this.state.errorInfoValue}>
                                    <Button size={'small'} type={'link'} onClick={() => {
                                        this.getFailure(record.id)
                                    }}>失败原因</Button>
                                </Popconfirm>
                                <style>{`.Failure .ant-popover-buttons{display:none !important;} `}</style>
                            </span>);
                                btns.push(failure);
                            }
                            // failure  end

                            // delBtn  Start
                            if(record.statusName.startsWith(`提交至${currentDeptValue}`) || (["弃用", "已弃用", "撤稿", "已撤稿", "发布", "已发布", "采用", "已采用", "修改完成并提交"].indexOf(record.statusName) > -1)) {
                                let delBtn =
                                    <Popconfirm key={"delBtn"} title="确定要移除吗？" okText="确定" cancelText="取消" onConfirm={() => {
                                        this.delete(record)
                                    }}>
                                        {
                                            (record.statusName.startsWith(`提交至${currentDeptValue}`) || (["弃用", "已弃用", "撤稿", "已撤稿", "发布", "已发布", "采用", "已采用", "修改完成并提交"].indexOf(record.statusName) > -1)) &&
                                            <Button size={'small'} type={'link'}>移除</Button>
                                        }
                                    </Popconfirm>;
                                btns.push(delBtn);
                            }
                            // delBtn  end

                            // task btn start
                            if(record.category==="manuscripts") {
                                let showTaskBtn = <Button size={'small'} type={'link'} onClick={()=>{this.showTask(record.id)}}>约稿详情</Button>;
                                btns.push(showTaskBtn);
                            }
                            // task btn end
                            return (
                                <div className={'a'}>
                                    {
                                        btns&&btns.length?(
                                            btns.map((btn,index)=>{
                                                if(index<3) {
                                                    return btn
                                                }
                                                if(index===3) {
                                                    let menus = btns.slice(3,btn.length);
                                                    menus= (
                                                        <Menu>
                                                            {
                                                                menus.map((menu,Index)=>(
                                                                    <Menu.Item key={Index}>
                                                                        {menu}
                                                                    </Menu.Item>
                                                                ))
                                                            }
                                                        </Menu>
                                                    );
                                                    return (
                                                        <Dropdown overlay={menus} placement="bottomLeft" key={index}>
                                                            <Icon type="ellipsis" />
                                                        </Dropdown>
                                                    )
                                                }
                                            })
                                        ):null
                                    }
                                </div>
                            )
                        }
                    }
                }
            })
        }
        console.log("columns================",columns)
        return columns
    }

    // 查看任务详情
    showTask = (storyId) => {
        if(storyId) {
            this.getContributeStory(storyId,(id)=>{
                this.request({
                    url: '/cm-sites-business/bd/busAppointment/page',
                    method: 'post',
                    contentType: 'json',
                    body: {
                        "size": -1,
                        "showRef": [
                            "receiverIds"
                        ],
                        "params": [
                            {
                                "key": "receiverObjs.storyId",
                                "opt": "eq",
                                "val": id
                            }
                        ]
                    },
                    callBack: (data) => {
                        if(data && data.data && data.data.length) {
                            let tasks = data.data;
                            let taskId = tasks[0].id;
                            if(taskId && this.detailsModal && typeof this.detailsModal.show === "function") {
                                this.detailsModal.show(taskId,{id:taskId,showBtn:false})
                            }
                        }
                    }
                })
            });
        }
    };

    // 根据收稿稿件获取投稿稿件
    getContributeStory = (storyId,call) => {
        if(storyId) {
            this.request({
                url: '/cm-sites-pms/story/getContributeStory',
                body: {storyId},
                callBack: (story) => {
                    if(story && story.id) {
                        call&&call(story.id)
                    }
                },
                errorCallBack: () => {

                }
            })
        }
    };

    getContributeIds = (data)=>{
        let ids = [];
        data && data.map(item => {
            if(item.activitiCategoryKey === "yggj"){
                if(item.data && item.data.targetIds && (item.data.targetIds instanceof Array) && (item.data.targetIds.length > 0)){
                    ids.push(item.data.id);
                }
            }
        });
        return ids;
    };

    getMediaNewIds = (data)=>{
        let ids = [];
        data && data.map(item => {
            if(item.activitiCategoryKey !== "yggj"){
                ids.push(item.data.id);
            }
        });
        return ids;
    };

    getReceiveIds = (data)=>{
        let ids = [];
        data && data.map(item => {
            if(item.activitiCategoryKey === "yggj"){
                if(item.data && item.data.mediaIds && (item.data.mediaIds instanceof Array) && (item.data.mediaIds.length > 0)){
                    ids.push(item.data.id);
                }
            }
        });
        return ids;
    };

}